import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'
export default [
  {
    path: routeNames.teamList,
    component: () => import('../../pages/teamManagement/teamList'),
    meta: { title: '战队管理' }
  },
  {
    path: routeNames.teamMember,
    component: () => import('../../pages/teamManagement/teamMember'),
    meta: { title: '战队成员' }
  },
  {
    path: routeNames.invitationRecord,
    component: () => import('../../pages/teamManagement/teamMember/invitationRecord'),
    meta: { title: '邀请记录', hideInMenu: true }
  },
  {
    path: routeNames.rewardRecord,
    component: () => import('../../pages/teamManagement/rewardRecord'),
    meta: { title: '奖励记录' }
  },
  {
    path: routeNames.teamTop,
    component: () => import('../../pages/teamManagement/teamTop'),
    meta: { title: '战队榜单' }
  },
  {
    path: routeNames.teamRewardSetting,
    component: () => import('../../pages/teamManagement/teamTop/teamRewardSetting'),
    meta: { title: '奖励设置', hideInMenu: true }
  },
  {
    path: routeNames.setTeamActivity,
    component: () => import('../../pages/teamManagement/setTeamActivity'),
    meta: { title: '战队活动基础配置' }
  }
] as TRoutes[]
